import ResponseError from "@/errors/ResponseError";
import fetchJson, { type FetchJsonResponse } from "../fetchJson/index";

export type EvaluateRestQueryResponse<T> = Promise<
  | {
      data: Awaited<FetchJsonResponse<T>> | null;
      error?: never;
    }
  | {
      error: typeof ResponseError;
      data?: never;
    }
>;

/**
 * Make a REST query, returning rather than throwing any error.
 * @param {(Request|string|URL)} resource - the resource (request or URL) to
 * query for
 *
 * returns  the result of the query as a promise
 */
const evaluateRestQuery = async <T>(
  resource: RequestInfo | URL,
): EvaluateRestQueryResponse<T> => {
  try {
    const data = await fetchJson<T>(resource);
    return { data };
  } catch (error) {
    const e = error as typeof ResponseError;

    return { error: e };
  }
};

export default evaluateRestQuery;
